import { call, put, takeLatest } from 'redux-saga/effects';
import { PolicyMap } from 'types';
import { policiesLoadSuccess, policiesLoadFailure } from 'actions/policyActions';
import { handleErrorSaga } from 'sagas/app/handleError';
import { getPolicies } from 'api';


export function* loadPoliciesRequestWatcher() {
    yield takeLatest('POLICIES_LOAD_REQUEST', loadPoliciesSaga);
}

export function* loadPoliciesSaga() {
    let policies: PolicyMap;
    try {
        policies = yield call(getPolicies);
    }
    catch (err) {
        yield call(handleErrorSaga, err, policiesLoadFailure);
        return;
    }
    yield put(policiesLoadSuccess(policies));
}



// WEBPACK FOOTER //
// ./src/sagas/policies/loadPoliciesSaga.ts